import React from 'react';

const Products = ({products_title, t}) => {

    const products = t('common:products', {}, {returnObjects: true});

    const ProductItem = ({slide, i}) => {
        return <li className={'products_list_item'}>
            <div className="products_list_item_wrapper">
                    <picture>
                        <source
                            srcSet={`/img/commons/products/product_bg_${slide.img}.webp`}
                            type="image/webp"
                        />
                        <img
                            src={`/img/commons/products/product_bg_${slide.img}.png`}
                            alt={`ColdWare ${slide.title}`}
                            width={209}
                            height={318}
                            className='product_bg'
                        />
                    </picture>
                <div className="slide_icon">
                    <picture>
                        <source
                            srcSet={`/img/commons/products/icon_${slide.icon}.webp`}
                            type="image/webp"
                        />
                        <source
                            srcSet={`/img/commons/products/icon_${slide.icon}.png`}
                        />
                        <img
                            src={`/img/commons/products/icon_${slide.icon}.png`}
                            alt={`ColdWare ${slide.title}`}
                            width={96}
                            height={96}
                            className='slide_icon_main'
                        />
                    </picture>
                    <picture>
                        <source
                            srcSet={`/img/commons/products/icon_${slide.icon}_hover.webp`}
                            type="image/webp"
                        />
                        <source
                            srcSet={`/img/commons/products/icon_${slide.icon}_hover.png`}
                        />
                        <img
                            src={`/img/commons/products/icon_${slide.icon}_hover.png`}
                            alt={`ColdWare ${slide.title}`}
                            width={96}
                            height={96}
                            className='slide_icon_hover'
                        />
                    </picture>
                </div>
                <h3 className={'slide_title'}>{slide.title}</h3>
                <p className={'slide_description'}>{slide.description}</p>
            </div>
        </li>
    }

    return (
        <>
            <div className="container">
                <div className={'products_title'}>
                    <h2>{products_title.title}</h2>
                    {products_title?.description && <p>{products_title.description}</p>}
                </div>
            </div>
            <section className={'products'}>
                <ul className="container products_list">
                    {products.map((slide, i) => {
                        return <ProductItem
                            key={slide.key}
                            slide={slide}
                            i={i}
                        />
                    })}
                </ul>
            </section>
            <div className={'scroll_hide_wrapper'}>
                <div className={'scroll_hide'}>
                    <div className="container">
                        <div className="scroll_hide_inner"/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Products;